export const serverIP = '/cluster-api/'
   // export const serverIP = 'http://localhost:9012/'




//////////////////
// WEBPACK FOOTER
// ./public/config.js
// module id = t3uW
// module chunks = 6